The details of how an advertisement product will be paid.
